import getBasePath from '../../../../../common/functions/api-resource';

const basePath = getBasePath('api', 'ano-fiscal');

const anoFiscalActions = {
  pesquisarPorTipo: { method: 'GET', url: `${basePath}/{idTipoVerba}` },
  pesquisarPorTipoVigente: { method: 'GET', url: `${basePath}?idTipoVerba={idTipoVerba}&vigenteOuComBloqueio=true` },
  alterarStatus: { method: 'PUT', url: `${basePath}/{id}/status` },
  gravar: { method: 'POST', url: `${basePath}` },
  periodos: { method: 'GET', url: `${basePath}/{idTipoVerba}/periodo` },
  buscarPeriodosAnoFiscal: { method: 'GET', url: `${basePath}/periodo?{&idsAnoFiscal*}` },
  buscar: { method: 'GET', url: `${basePath}` },
  autocompletePeriodo: { method: 'GET', url: `${basePath}/1/periodo/autocomplete` },
  periodoPaginado: { method: 'GET', url: `${basePath}/1/periodo/paginado` },
};

export default resource => resource(`${basePath}`, {}, anoFiscalActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/ano-fiscal/ano-fiscal.js